import React from 'react';
import Main from './Main';
import AppEnv from './Env/AppEnv';

const SSOSuiteApp: React.FC = () => (
	<>
		<AppEnv />
		<Main />
	</>
);

export default SSOSuiteApp;
